import { lazy } from "react";
import { PathRouteProps } from "react-router-dom";
import { Path } from "../types/routes";

export interface R extends PathRouteProps {
  name: string;
  path: Path | string;
  protected?: boolean;
}

const Home = lazy(() => import("../features/home/Home"));
const About = lazy(() => import("../features/about/About"));
const NotFound = lazy(() => import("../features/notFound/NotFound"));
const HangMan = lazy(() => import("../features/game/games/HangMan/hangMan"));
const SpellingLetters = lazy(
  () => import("../features/game/games/spellingLetters/spellingLetters")
);
const SpellingWords = lazy(
  () => import("../features/game/games/spellingWords/spellingWords")
);
const Wordle = lazy(() => import("../features/game/games/Wordle/wordle"));
const AlphabetQuiz = lazy(
  () => import("../features/game/games/AlphabetQuiz/AlphabetQuiz")
);
const MemoryMatch = lazy(
  () => import("../features/game/games/MemoryMatch/MemoryMatch")
);
const SpeedSign = lazy(
  () => import("../features/game/games/SpeedSign/SpeedSign")
);
const NumberSigns = lazy(
  () => import("../features/game/games/NumberSigns/NumberSigns")
);
const FillInBlank = lazy(
  () => import("../features/game/games/FillInBlank/FillInBlank")
);
const SignBingo = lazy(
  () => import("../features/game/games/SignBingo/SignBingo")
);
const Games = lazy(() => import("../features/games/Games"));
const HandSign = lazy(() => import("../features/HandSigns/HandSign"));
const Practice = lazy(() => import("../features/practice/PracticePage"));
const Translate = lazy(() => import("../features/translate/TranslatePage"));

const routes: readonly R[] = [
  { element: <Home />, name: "Home", path: Path.Home },
  { element: <About />, name: "About", path: Path.About },
  { element: <Practice />, name: "Practice", path: Path.Practice },
  { element: <Practice />, name: "PracticeUnit", path: Path.PracticeUnit },
  { element: <Translate />, name: "Translate", path: Path.Translate },
  { element: <HangMan />, name: "HangMan", path: Path.HangMan },
  {
    element: <SpellingLetters />,
    name: "SpellingLetters",
    path: Path.SpellingLetters,
  },
  {
    element: <SpellingWords />,
    name: "SpellingWords",
    path: Path.SpellingWords,
  },
  { element: <Wordle />, name: "Wordle", path: Path.Wordle },
  { element: <AlphabetQuiz />, name: "AlphabetQuiz", path: Path.AlphabetQuiz },
  { element: <MemoryMatch />, name: "MemoryMatch", path: Path.MemoryMatch },
  { element: <SpeedSign />, name: "SpeedSign", path: Path.SpeedSign },
  { element: <NumberSigns />, name: "NumberSigns", path: Path.NumberSigns },
  { element: <FillInBlank />, name: "FillInBlank", path: Path.FillInBlank },
  { element: <SignBingo />, name: "SignBingo", path: Path.SignBingo },
  { element: <Games />, name: "Games", path: Path.Games },
  { element: <HandSign />, name: "HandSign", path: Path.HandSigns },
  { element: <NotFound />, name: "NotFound", path: "*" },
] as const;

export default routes;
